import { useCallback, useEffect, useState } from 'react';

import { useAttachmentSignedUrl } from 'hooks/useAttachmentSignedUrl';

export function useClickAttachment(attachmentId: string, attachableModel?: string, page?: number) {
  const [attachmentToFetchId, setAttachmentToFetchId] = useState<string>('');

  const { data: attachmentData, isStale, refetch } = useAttachmentSignedUrl(attachmentToFetchId, attachableModel);

  const openUrl = useCallback(
    (url: string) => {
      const target = typeof page === 'number' ? `${url}#page=${page}` : url;
      window.open(target, '_blank');
    },
    [page]
  );

  const openAttachment = useCallback(() => {
    if (isStale) {
      refetch();
    } else if (attachmentData?.url) {
      openUrl(attachmentData.url);
    } else {
      setAttachmentToFetchId(attachmentId);
    }
  }, [attachmentId, isStale, attachmentData?.url, refetch, openUrl]);

  useEffect(() => {
    if (attachmentData?.url) {
      openUrl(attachmentData.url);
    }
  }, [attachmentData?.url, openUrl]);

  return openAttachment;
}
